import React, { useState } from "react";
import { Container, Row, Col, Button, Modal, ModalBody, ModalFooter, Card, CardBody, FormFeedback, Label, Input } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import Select from "react-select";

//i18n
import { withTranslation } from "react-i18next";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';


const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const UserManagement = props => {
  const [modal_Delete_User, setmodal_Delete_User] = useState(false);
  function Delete_User() {
    setmodal_Delete_User(!modal_Delete_User);
    // removeBodyCss();
  }


  
  //meta title
  document.title = "User Management";
	const location = useLocation();
  const { getRequest, postRequest } = useRequests();


  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};
  
  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      kyc_status: 'All',
      status: 'All',
      country: {label: 'All', value: 'All'},
    },
    validationSchema: Yup.object({
    }),
    onSubmit: (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        let filteredData = UsersData;
        if(values.kyc_status !== 'All') {
          filteredData = filteredData.filter(item => item.kyc_status === values.kyc_status);
        }
        if(values.status !== 'All') {
          filteredData = filteredData.filter(item => item.status === values.status);
        }
        if(values.country.value !== 'All') {
          filteredData = filteredData.filter(item => item.country === values.country.value);
        }

        if(filteredData.length > 0) {
          handleT1Body(filteredData);
        }
        else {
          let tempTBody = (<tr>
                          <td colSpan="9" className="text-center">No records found</td>
                        </tr>);

          setUsersTBody(tempTBody);
        }

        submit1.disabled = false;
        submit1.textContent = 'Search';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [StandardModal2, setStandardModal2] = React.useState(false);
  const togStandardModal2 = async (elementData) => {
    validation2.setValues({
      ...validation2.values,
      u_id: elementData.u_id,
      status: elementData.status,
    });
    setStandardModal2(true);
  }

  const validation2 = useFormik({
    enableReinitialize: true,

    initialValues: {
      u_id: '',
      status: '',
    },
    validationSchema: Yup.object({
      status: Yup.string().required('Please select status'),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit2');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          u_id: values.u_id,
          status: values.status
        });
        const res = await postRequest('update-user-status', jsonpar);
        if (res && res.code === 200) {
          handleLoadGetUsers();
          setTimeout(() => {
            validation1.handleSubmit();
          }, 500);

          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: res.message,
          }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Update';

        setStandardModal2(false);
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  }); 

  const [StandardModal, setStandardModal] = React.useState(false);
  const togStandardModal = async (elementData) => {
    validation.setValues({
      ...validation.values,
          u_id: elementData.u_id,
      });
      setStandardModal(true);
  }

      const validation = useFormik({
          enableReinitialize: true,
  
          initialValues: {
          u_id: '',
          welcome_bonus: '',
          referral_code: ''
          },
          validationSchema: Yup.object({
            welcome_bonus: Yup.number()
            .typeError('Welcome bonus must be a number')
            .required('Please enter welcome bonus')
            .positive('Welcome bonus must be greater than 0'),
            referral_code: Yup.string().required('Please enter referral code'),
          }),
          onSubmit: async (values) => {
          try {
              let submit1 = document.getElementById('submit1');
              submit1.disabled = true;
              submit1.textContent = 'Processing...';
  
              const jsonpar = JSON.stringify({
              u_id: values.u_id,
              collaborator_welcome_bonus: values.welcome_bonus,
              collaborator_referral_code: values.referral_code
              });
              const res = await postRequest('make-collaborator', jsonpar);
              if (res && res.code === 200) {  
                  setAlertData((AlertData) => ({
                  ...AlertData,
                  variant: 'success',
                  message: res.message,
                  }));
              }
              else {
              setAlertData((AlertData) => ({
                  ...AlertData,
                  variant: 'error',
                  message: res.message,
              }));
              }
              resetAlertData();
              
              submit1.disabled = false;
              submit1.textContent = 'Submit';
  
              setStandardModal(false);
              handleLoadGetUsers();
          } catch (error) {
              console.error("Error : ", error);
          }
          }
      });

  const [UsersData, setUsersData] = React.useState([]);
  const [UsersTBody, setUsersTBody] = React.useState('');
  const handleT1Body = async (tempData) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.u_id}</td>
        <td>{element.first_name}</td>
        <td>{element.last_name}</td>
        <td>{element.email}</td>
        <td>{element.country}</td>
        <td>+{element.country_code} {element.phone.slice(0, 6)}****&nbsp;
            {parseInt(element.is_phone_verified) === 1 ? (
              <CheckCircleIcon style={{ color: 'green' }} />
            ) : (
              <CancelIcon style={{ color: 'red' }} />
            )}
        </td>
        <td><span className={"font-size-14 badge bg-secondary rounded-pill " + (element.kyc_status === 'Pending' ? 'badge-soft-warning' : element.kyc_status === 'Approved' ? 'badge-soft-success' : 'badge-soft-danger')}>{element.kyc_status}</span></td>
        <td><span className={"font-size-14 badge bg-secondary rounded-pill " + (element.status === 'Enable' ? 'badge-soft-success' : 'badge-soft-danger')}>{element.status}</span></td>
        <td className="text-center">
          <div className="centerLink">
            <Link title="Edit Status" to="#" className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal2(element)}><i className="bx bx-cog"></i></Link>
            <Link title="Edit User" to={"/edit_user/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bxs-edit"></i></Link>
            {/* <Link title="Delete User" to="#" className="font-size-14 bg-primary edit-box" onClick={() => { Delete_User(); }}><i className="bx bx-trash"></i></span> */}
            <Link title="Transactions" to={"/transaction/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bx-list-ul"></i></Link>
            <Link title="User KYC" to={"/user_kyc/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bxs-user-check"></i></Link>
            <Link title="Dividend Transactions" to={"/dividends_transactions/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bx-wallet-alt"></i></Link>
            <Link title="Withdrawal Transactions" to={"/withdrawal_request/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bx-transfer-alt"></i></Link>
            <Link title="User Wallet" to={"/user_wallet/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bx-wallet"></i></Link>
            <Link title="User Portfolio" to={"/portfolio/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bx-cart-alt"></i></Link>
            <Link title="Referral List" to={"/referral/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="mdi mdi-trophy-award"></i></Link>
            <Link title="Referral Reward" to={"/referral_reward/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bx-award"></i></Link>
            <Link title="Referral Reward" to={"/referral_reward/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bx-award"></i></Link>
            {
            element.collaborator_referral_code?""
            :<Link title="Make Collaborator" to="#" className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal(element)}><i className="fas fa-handshake"></i></Link>
            }
            {/* <Button className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal(element)}><i className="bx bx-cog"></i></Button> */}
          </div>
        </td>
      </tr>
    ));

    setUsersTBody(tempTBody);
  }
  const handleLoadGetUsers = async () => {
    const res = await getRequest('get-users');
    if (res && res.code === 200) {
      let originalText = res.data;

      setUsersData(originalText);

      handleT1Body(originalText);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="9" className="text-center">No records found</td>
                      </tr>);

      setUsersTBody(tempTBody);

      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  const [AllCountriesData, setAllCountriesData] = React.useState([]);
  const handleLoadGetAllCountries = async () => {
    const res = await getRequest('get-all-countries');
    if (res && res.code === 200) {
      let originalText = res.data;

      let tempArr = [{label: 'All', value: 'All'}];
      originalText.forEach(element => {
        let temp = {
            label: element.country_name,
            value: element.country_name,
        };
        tempArr.push(temp);
      });
      tempArr = [{
          options: tempArr
      }];
      setAllCountriesData(tempArr);
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }
  React.useEffect(() => {
    handleLoadGetUsers();
    handleLoadGetAllCountries();

    if (typeof location.state !== 'undefined' && typeof location.state.message !== 'undefined') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
		}
  }, []);


  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("User Management")} />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div className="row">
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">KYC Status : </label>
                          <select className="form-select" name="kyc_status" value={validation1.values.kyc_status} onChange={(e) => validation1.setValues({ ...validation1.values, kyc_status: e.target.value })}>
                            <option value={'All'}>All</option>
                            <option value={'Pending'}>Pending</option>
                            <option value={'Approved'}>Approved</option>
                            <option value={'Cancelled'}>Cancelled</option>
                          </select>
                        </div>
                      </Col>
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Status : </label>
                          <select className="form-select" name="status" value={validation1.values.status} onChange={(e) => validation1.setValues({ ...validation1.values, status: e.target.value })}>
                            <option value={'All'}>All</option>
                            <option value={'Enable'}>Enable</option>
                            <option value={'Disable'}>Disable</option>
                          </select>
                        </div>
                      </Col>
                      <Col md={3} xs={12}>
                        <div className="mb-3 Register-Select2">
                          <label className="form-label">Country : </label>
                          <Select styles={colourStyles} value={validation1.values.country} onChange={(e) => validation1.setValues({ ...validation1.values, country: e })} options={AllCountriesData} classNamePrefix="select2-selection" />
                        </div>
                      </Col>
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label fullWidth">&nbsp; </label>
                          <Button type="button" 
                            id="submit1"
                            onClick={(e) => {
                              e.preventDefault();
                              validation1.handleSubmit();
                              return false;
                            }}
                          color="primary">Search</Button>
                        </div>
                      </Col>
                    </div>
                    <div className="table-responsive mb-0">
                      <table className="table table-hover table-highlight" style={{ minWidth: '1500px' }}>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email ID</th>
                            <th>Country Name</th>
                            <th>Mobile No.</th>
                            <th>KYC Status</th>
                            <th>Status</th>
                            <th className="text-center" style={{ width: '500px' }}>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {UsersTBody}
                        </tbody>
                      </table>
                    </div>
                    <div className="infoIcon">

                      <div className="infoIconBox">
                        <i className="bx bxs-edit"></i>
                        <p>Edit User</p>
                      </div>

                      {/* <div className="infoIconBox">
                        <i className="bx bx-trash"></i>
                        <p>Delete User</p>
                      </div> */}

                      <div className="infoIconBox">
                        <i className="bx bx-list-ul"></i>
                        <p>Transactions</p>
                      </div>

                      <div className="infoIconBox">
                        <i className="bx bxs-user-check"></i>
                        <p>User KYC</p>
                      </div>

                      <div className="infoIconBox">
                        <i className="bx bx-wallet-alt"></i>
                        <p>Dividend Transactions</p>
                      </div>

                      <div className="infoIconBox">
                        <i className="bx bx-transfer-alt"></i>
                        <p>Withdrawal Transactions</p>
                      </div>

                      <div className="infoIconBox">
                        <i className="bx bx-wallet"></i>
                        <p>User Wallet</p>
                      </div>

                      <div className="infoIconBox">
                        <i className="bx bx-cart-alt"></i>
                        <p>User Portfolio</p>
                      </div>

                      <div className="infoIconBox">
                        <i className="mdi mdi-trophy-award"></i>
                        <p>Referral List</p>
                      </div>

                      <div className="infoIconBox">
                        <i className="bx bx-award"></i>
                        <p>Referral Reward</p>
                      </div>

                      <div className="infoIconBox">
                        <i className="fas fa-handshake"></i>
                        <p>Make Collaborator</p>
                      </div>

                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

        </Container>
      </div>

      <Modal isOpen={modal_Delete_User} toggle={() => { Delete_User(); }} backdrop={'static'} centered className="transation">
        <div>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Delete User</h5>
            <button type="button" onClick={() => { setmodal_Delete_User(false); }} className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ModalBody>
            <p>Are you sure you wan't to delete this user?</p>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="primary" onClick={() => { setmodal_Delete_User(false); }} >Delete</Button>
            <Button type="button" color="light" onClick={() => { setmodal_Delete_User(false); }} >Cancel</Button>
          </ModalFooter>
        </div>
      </Modal>

      <Modal isOpen={StandardModal2} backdrop={'static'} centered className="transation">
        <div>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Change Status</h5>
            <button type="button" onClick={(e)=>setStandardModal2(false)} className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ModalBody>
            <div className="mb-3">
              <label className="form-label">Select Status :</label>
              <select className="form-select" name="status" value={validation2.values.status} onChange={(e) => validation2.setValues({ ...validation2.values, status: e.target.value })}>
                <option value="Enable">Enable</option>
                <option value="Disable">Disable</option>
              </select>
              {validation2.touched.status && validation2.errors.status ? (
                <FormFeedback type="invalid">{validation2.errors.status}</FormFeedback>
              ) : null}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="primary"
              id="submit2"
              onClick={(e) => {
                e.preventDefault();
                validation2.handleSubmit();
                return false;
              }}
            >Update</Button>
            <Button type="button" color="light" onClick={(e)=>setStandardModal2(false)} >Cancel</Button>
          </ModalFooter>
        </div>
      </Modal>

      <Modal isOpen={StandardModal} backdrop={'static'} centered className="transation">
        <div>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Make Collaborator</h5>
            <button type="button" onClick={(e)=>setStandardModal(false)} className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ModalBody>
          <div className="mb-3">
                    <Label className="form-label">Welcome Bonus :</Label>
                    <Input
                      name="welcome_bonus" 
                      type="text" 
                      placeholder={'Enter Welcome Bonus'}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.welcome_bonus || ""}
                      invalid={
                        validation.touched.welcome_bonus && validation.errors.welcome_bonus ? true : false
                      }
                    />
                    {validation.touched.welcome_bonus && validation.errors.welcome_bonus ? (
                      <FormFeedback type="invalid">{validation.errors.welcome_bonus}</FormFeedback>
                    ) : null}
                  </div>

                  <div className="mb-3">
                    <Label className="form-label">Referral code  :</Label>
                    <Input
                      name="referral_code" 
                      type="text" 
                      placeholder={'Enter Referral code'}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.referral_code || ""}
                      invalid={
                        validation.touched.referral_code && validation.errors.referral_code ? true : false
                      }
                    />
                    {validation.touched.referral_code && validation.errors.referral_code ? (
                      <FormFeedback type="invalid">{validation.errors.referral_code}</FormFeedback>
                    ) : null}
                  </div>
          </ModalBody>
          <ModalFooter>
            <Button 
              id="submit1"
              onClick={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            type="button" color="primary" >Submit</Button>
            <Button type="button" color="light" onClick={(e)=>setStandardModal(false)} >Cancel</Button>
          </ModalFooter>
        </div>
      </Modal>

    </React.Fragment>
  );
};

export default withTranslation()(UserManagement);